import { pick } from 'lodash';

export const buildEntityParams = (
  isServer: boolean,
  params?: Record<string, any>,
): Record<string, any> => {
  const pickedParams = isServer
    ? (params ?? {})
    : pick(params ?? {}, ['page', 'limit', 'sort', 'sort_by']);

  return {
    ...pickedParams,
    page: pickedParams.page ?? 1,
    limit: pickedParams.limit ?? (isServer ? 20 : 9999),
  };
};
